// src/index.js o src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { loadAndApplyActiveTheme } from './components/Sistema/Utils/ThemeManager';
import { LogoProvider } from './context/LogoProvider';
import axios from 'axios';
import { clearSessionUser, getSessionXsrfToken } from './utils/SessionUser';

// --- INICIO: Interceptor Global (Opción 1) Anti-Doble Clic ---
let activeRequests = 0;

const hideOverlay = () => {
  const overlay = document.getElementById('global-axios-overlay');
  if (overlay) {
    overlay.remove();
  }
};

// Interceptor de REQUEST
axios.defaults.withCredentials = true; // Activar globalmente para compatibilidad con cookies HttpOnly (FASE 4)
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'; // Nombre de la cookie para CSRF
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'; // Nombre del header para CSRF

// Función auxiliar para leer cookies desde JS (Mantenida por si se necesita para otras cookies)
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

axios.interceptors.request.use((config) => {
  // --- SEGURIDAD JWT (FASE 4): El navegador gestiona el token automáticamente vía cookies ---

  // --- SEGURIDAD CSRF (FASE 5): Inyectar header usando el token guardado en sesión (evita problemas CORS) ---
  const xsrfToken = getSessionXsrfToken();
  if (xsrfToken) {
    config.headers['X-XSRF-TOKEN'] = xsrfToken;
  }

  // Si la petición va a modificar datos, encendemos el bloqueo
  const method = config.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests++;
    //showOverlay();
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Interceptor de RESPONSE
axios.interceptors.response.use((response) => {
  const method = response.config?.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests--;
    if (activeRequests <= 0) {
      activeRequests = 0;
      hideOverlay();
    }
  }
  return response;
}, (error) => {
  // --- INICIO: Manejo de Seguridad 401 ---
  if (error.response && error.response.status === 401) {
    console.warn('Sesión expirada o no autorizada (401).');
    clearSessionUser();
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login';
    }
  }
  // --- FIN: Manejo de Seguridad 401 ---

  const method = error.config?.method?.toLowerCase();
  if (['post', 'put', 'delete', 'patch'].includes(method)) {
    activeRequests--;
    if (activeRequests <= 0) {
      activeRequests = 0;
      hideOverlay();
    }
  }
  return Promise.reject(error);
});
// --- FIN: Interceptor Global ---

// Cargar y aplicar variables de identidad visual desde la BD al iniciar
loadAndApplyActiveTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <LogoProvider>
      <App />
    </LogoProvider>
  </BrowserRouter>
);
